jQuery(document).ready(function($){
    /**
     * @decription
     */
    function initShopOrderingDropdowns() {
        $('.woocommerce-ordering').removeClass('hide-it');
        $('.show-in-page').removeClass('hide-it');
    }

    function initFilterSpinner() {
        const shopWrapper = $('.wc-shop__wrapper');
        const spinner = '<div class="vet-spinner vet-spinner--large vet-spinner--fixed loaded"></div>';
        const checkbox = $('.wpc-term-item-content-wrapper input');

        checkbox.on('change', function(){
            shopWrapper.append(spinner);
        });

    }


    initShopOrderingDropdowns();
    initFilterSpinner();

    $( document ).on('vet-filters-ajax-complete', function() {
        initShopOrderingDropdowns();
    });
});